import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Watch, ArrowLeft } from 'lucide-react';

const LegalPageLayout = ({ title, children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-sans">
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.06] bg-[#0a0a0a]/80 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-90 transition-opacity">
            <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center">
              <Watch className="w-4 h-4 text-[#0a0a0a]" />
            </div>
            <span className="font-semibold text-[15px] tracking-tight">Dial-Grid</span>
          </Link>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm font-medium text-white/80 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        </div>
      </nav>

      <main className="pt-28 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white mb-8">{title}</h1>
          <div className="prose prose-invert prose-sm max-w-none text-white/80 leading-relaxed space-y-6">
            {children}
          </div>
        </div>
      </main>

      <footer className="py-8 px-6 border-t border-white/[0.06]">
        <div className="max-w-6xl mx-auto text-center">
          <Link to="/" className="text-sm text-white/50 hover:text-white transition-colors">
            &larr; Return to Dial-Grid
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default LegalPageLayout;
